// src/services/adminJournal.js
// Journal d'audit Admin — GET /admin/journal · POST /admin/journal/archiver

import { apiFetch, buildQuery } from './adminHttp';

/**
 * GET /admin/journal
 * Query : limite, decalage, niveau_gravite, action, cible_type
 * Permission : JOURNAL_VOIR (Super Admin bypass)
 * limite plafonnée à 200 côté Worker (défaut 50). Pas de total inventé.
 */
export async function getJournal(params = {}) {
  return apiFetch(`/admin/journal${buildQuery(params)}`, {
    method: 'GET',
  });
}

/**
 * POST /admin/journal/archiver
 * Super Admin exclusif. Body vide.
 */
export async function archiverJournal() {
  return apiFetch('/admin/journal/archiver', {
    method: 'POST',
    body: JSON.stringify({}),
  });
}
